import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/chain/arbitrum_24.svg.ts
import { svg } from "lit";
var arbitrum24Svg = ({ width, height }) => svg`
<svg width="${width ?? 24}" height="${height ?? 24}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="12" fill="#2D374B"/>
  <g clip-path="url(#clip0_6718_21386)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6817 4.67886C12.2597 4.44038 11.7398 4.44038 11.3178 4.67886L5.86332 7.76148C5.44149 7.99988 5.18164 8.44038 5.18164 8.91708V15.0829C5.18164 15.5596 5.44149 16.0001 5.86332 16.2385L11.3178 19.3211C11.7398 19.5596 12.2597 19.5596 12.6817 19.3211L18.1362 16.2385C18.5581 16.0001 18.8179 15.5596 18.8179 15.0829V8.91708C18.8179 8.44038 18.5581 7.99988 18.1362 7.76148L12.6817 4.67886ZM12.2498 5.47845C12.1091 5.39892 11.9358 5.39892 11.7951 5.47845L6.3974 8.52985C6.25682 8.60933 6.17023 8.75615 6.17023 8.91503V15.0183C6.17023 15.1771 6.25682 15.324 6.3974 15.4034L11.7951 18.4548C11.9358 18.5344 12.1091 18.5344 12.2498 18.4548L17.6475 15.4034C17.7881 15.324 17.8747 15.1771 17.8747 15.0183V8.91503C17.8747 8.75615 17.7881 8.60933 17.6475 8.52985L12.2498 5.47845Z" fill="#96BEDC"/>
    <path d="M6.6785 16.699L5.70528 16.149C5.38171 15.9662 5.18164 15.6233 5.18164 15.2516L8.83797 9.77637C9.23672 9.17925 9.91642 8.81934 10.6453 8.81934H11.6986L6.6785 16.699Z" fill="white"/>
    <path d="M9.00203 18.0122L7.25163 17.0229L12.352 8.81934H14.5623L9.00203 18.0122Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1091 16.2732L14.1691 17.3699L12.0566 14.1351L13.3521 12.0111L16.1091 16.2732ZM17.8748 14.0789V15.0182C17.8748 15.1771 17.7882 15.3239 17.6476 15.4034L16.662 15.9606L13.7271 11.3494L14.8521 9.50342L17.8748 14.0789Z" fill="#28A0F0"/>
  </g>
  <defs>
    <clipPath id="clip0_6718_21386">
      <rect width="15" height="15" fill="white" transform="translate(4.5 4.5)"/>
    </clipPath>
  </defs>
</svg>
`;
export {
  arbitrum24Svg
};
//# sourceMappingURL=arbitrum_24.svg-EOHJT7SH.js.map
